import type { FieldPolicy } from "@apollo/client";

interface FilteredEntityData {
  count: number;
  [key: string]: unknown;
}

export function createFilteredEntityTypePolicy(
  entityName: string,
  keyArgs: FieldPolicy["keyArgs"] = ["filters"],
): FieldPolicy<FilteredEntityData> {
  return {
    keyArgs,
    merge(existing, incoming, { args }) {
      const existingData = existing ?? { [entityName]: [], count: 0 };
      const existingItems = (existingData[entityName] as unknown[]) || [];
      const incomingItems = (incoming[entityName] as unknown[]) || [];
      const offset = (args?.filters as { offset?: number })?.offset || 0;

      if (offset === 0) {
        return {
          ...incoming,
          [entityName]: incomingItems,
        };
      }

      const merged = [...existingItems];
      incomingItems.forEach((item, index) => {
        merged[offset + index] = item;
      });

      return {
        count: incoming.count || existingData.count,
        [entityName]: merged,
      };
    },
  };
}
